webpackJsonp([5],{

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/actions/gmail.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);


function refreshToken(user, fetch) {
  return fetch('/api/google/refresh-token', {
    method: 'POST',
    body: JSON.stringify({
      refreshToken: user.refreshToken,
      accessToken: user.accessToken
    })
  }).then(function (response) {
    return response.json();
  });
}

/* **************************************************************************/
// Label
/* **************************************************************************/

function fetchLabelInfo(user, labelId) {
  var url = "https://www.googleapis.com/gmail/v1/users/me/labels/";
  return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url + labelId, {
    method: 'GET',
    headers: { "Authorization": "Bearer " + user.accessToken }
  }).then(function (response) {
    return response.json();
  });
}

function fetchAllLabels(user) {
  var url = "https://www.googleapis.com/gmail/v1/users/me/labels";
  return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url, {
    method: 'GET',
    headers: { "Authorization": "Bearer " + user.accessToken }
  }).then(function (response) {
    return response.json();
  });
}

function fetchMultipleLabelInfo(user, labelIds) {
  var allFetches = [];

  var _loop = function _loop() {
    var labelId = labelIds[i];
    var promise = fetchLabelInfo(user, labelId).then(function (data) {
      var queryString = 'labelIds=UNREAD&labelIds=' + labelId;
      return fetchThreadIds(user, '?' + queryString).then(function (threadData) {
        var threads = threadData.threads || [];
        if (threads.length === 0) {
          data.latestUnreadThreads = [];
          return data;
        }
        data.latestUnreadThreads = threadData.threads;
        return data;
      });
    });
    allFetches.push(promise);
  };

  for (var i = 0; i < labelIds.length; i++) {
    _loop();
  }
  return Promise.all(allFetches);
}

function fetchHistory(user, startHistoryId) {
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var url = 'https://www.googleapis.com/gmail/v1/users/me/history' + '?startHistoryId=' + startHistoryId;
  return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url, {
    method: 'GET',
    headers: { "Authorization": "Bearer " + user.accessToken }
  }).then(function (response) {
    if (response.status === 404 || response.status === 400) {
      return { invalidHistoryId: true };
    } else {
      return response.json();
    }
  });
}

/* **************************************************************************/
// Fetch Emails and messages
/* **************************************************************************/

function fetchMessageIds(user, query) {
  var url = "https://www.googleapis.com/gmail/v1/users/me/messages";
  return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url + query, {
    method: 'GET',
    headers: { "Authorization": "Bearer " + user.accessToken }
  }).then(function (response) {
    return response.json();
  });
}

function fetchThreadIds(user, query) {
  var url = "https://www.googleapis.com/gmail/v1/users/me/threads";
  return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url + query, {
    method: 'GET',
    headers: { "Authorization": "Bearer " + user.accessToken }
  }).then(function (response) {
    return response.json();
  });
}

function fetchThread(user, threadId) {
  var url = "https://www.googleapis.com/gmail/v1/users/me/threads/";
  return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url + threadId, {
    method: 'GET',
    headers: { "Authorization": "Bearer " + user.accessToken }
  }).then(function (response) {
    if (response.status === 404) {
      // thread has been deleted or doesn't exist
      return { id: threadId, deleted: true };
    } else {
      return response.json();
    }
  });
}

function fetchMessage(user, messageId) {
  var url = "https://www.googleapis.com/gmail/v1/users/me/messages/";
  return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url + messageId, {
    method: 'GET',
    headers: { "Authorization": "Bearer " + user.accessToken }
  }).then(function (response) {
    if (response.status === 404) {
      // message has been deleted or doesn't exist
      return { id: messageId, deleted: true };
    } else {
      return response.json();
    }
  });
}

function fetchManyThreads(user, threadIds) {
  var allFetches = [];
  for (var i = 0; i < threadIds.length; i++) {
    var threadId = threadIds[i];
    allFetches.push(fetchThread(user, threadId));
  }
  return Promise.all(allFetches);
}

function fetchManyMessages(user, messageIds) {
  var allFetches = [];
  for (var i = 0; i < messageIds.length; i++) {
    var messageId = messageIds[i];
    allFetches.push(fetchMessage(user, messageId));
  }
  return Promise.all(allFetches);
}

function fetchAttachment(user, messageId, attachmentId) {
  var url = "https://www.googleapis.com/gmail/v1/users/me/messages/" + messageId + "/attachments/" + attachmentId;
  return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url, {
    method: 'GET',
    headers: { "Authorization": "Bearer " + user.accessToken }
  }).then(function (response) {
    if (response.status === 404) {
      // somehow attachment doesn't exist, shouldn't happen
      return { id: null };
    } else {
      return response.json();
    }
  });
}

function fetchManyAttachments(user, messageId, attachmentIds) {
  var allFetches = [];
  for (var i = 0; i < attachmentIds.length; i++) {
    var attachmentId = attachmentIds[i];
    allFetches.push(fetchAttachment(user, messageId, attachmentId));
  }
  return Promise.all(allFetches);
}

/* **************************************************************************/
// Modify Emails and messages
/* **************************************************************************/

function changeLabels(user, threadId, labelsToAdd, labelsToRemove) {
  var url = "https://www.googleapis.com/gmail/v1/users/me/threads/" + threadId + "/modify";
  return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url, {
    method: 'POST',
    headers: {
      "Authorization": "Bearer " + user.accessToken,
      "Content-Type": 'application/json',
      "Accept": 'application/json'
    },
    body: JSON.stringify({
      addLabelIds: labelsToAdd,
      removeLabelIds: labelsToRemove
    })
  }).then(function (response) {
    return response.json();
  });
}

function trashThread(user, threadId) {
  var url = "https://www.googleapis.com/gmail/v1/users/me/messages/" + threadId + "/trash";
  return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url, {
    method: 'POST',
    headers: {
      "Authorization": "Bearer " + user.accessToken,
      "Content-Type": 'application/json',
      "Accept": 'application/json'
    }
  }).then(function (response) {
    return response.json();
  });
}

/* **************************************************************************/
// Modify Emails and messages
/* **************************************************************************/

function modifyLabel(user, labelId, reqBody) {
  var url = "https://www.googleapis.com/gmail/v1/users/me/labels/" + labelId;
  return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url, {
    method: 'PATCH',
    headers: {
      "Authorization": "Bearer " + user.accessToken,
      "Content-Type": 'application/json',
      "Accept": 'application/json'
    },
    body: JSON.stringify(reqBody)
  }).then(function (response) {
    return response.json();
  });
}

function createLabel(user, reqBody) {
  var url = "https://www.googleapis.com/gmail/v1/users/me/labels";
  return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url, {
    method: 'POST',
    headers: {
      "Authorization": "Bearer " + user.accessToken,
      "Content-Type": 'application/json',
      "Accept": 'application/json'
    },
    body: JSON.stringify(reqBody)
  }).then(function (response) {
    return response.json();
  });
}
// CONCATENATED MODULE: ./src/actions/mailbox.js
/* harmony export (immutable) */ __webpack_exports__["moveLabel"] = moveLabel;
/* harmony export (immutable) */ __webpack_exports__["moveCard"] = moveCard;
/* harmony export (immutable) */ __webpack_exports__["toggleDragging"] = toggleDragging;
/* harmony export (immutable) */ __webpack_exports__["sortEmails"] = sortEmails;
/* harmony export (immutable) */ __webpack_exports__["formatEmail"] = formatEmail;
/* harmony export (immutable) */ __webpack_exports__["updateLabelsToShow"] = updateLabelsToShow;
/* harmony export (immutable) */ __webpack_exports__["refreshAuth"] = refreshAuth;
/* harmony export (immutable) */ __webpack_exports__["requestFetchAllLabels"] = requestFetchAllLabels;
/* harmony export (immutable) */ __webpack_exports__["fetchAllLabels"] = mailbox_fetchAllLabels;
/* harmony export (immutable) */ __webpack_exports__["fullSyncMailBoxLabel"] = fullSyncMailBoxLabel;
/* harmony export (immutable) */ __webpack_exports__["fetchMultipleLabelInfo"] = mailbox_fetchMultipleLabelInfo;
/* harmony export (immutable) */ __webpack_exports__["fetchLabelInfo"] = mailbox_fetchLabelInfo;
/* harmony export (immutable) */ __webpack_exports__["fullSyncMultipleLabels"] = fullSyncMultipleLabels;
/* harmony export (immutable) */ __webpack_exports__["syncMailBoxLabel"] = syncMailBoxLabel;
/* harmony export (immutable) */ __webpack_exports__["addLabelToShow"] = addLabelToShow;
/* harmony export (immutable) */ __webpack_exports__["requestPartialSyncMailBox"] = requestPartialSyncMailBox;
/* harmony export (immutable) */ __webpack_exports__["requestChangeLabelToShow"] = requestChangeLabelToShow;
/* harmony export (immutable) */ __webpack_exports__["requestRemoveLabelToShow"] = requestRemoveLabelToShow;
/* harmony export (immutable) */ __webpack_exports__["moveThread"] = moveThread;
/* harmony export (immutable) */ __webpack_exports__["editThreadLabels"] = editThreadLabels;
/* harmony export (immutable) */ __webpack_exports__["markAsRead"] = markAsRead;
/* harmony export (immutable) */ __webpack_exports__["archiveThread"] = archiveThread;
/* harmony export (immutable) */ __webpack_exports__["trashThread"] = mailbox_trashThread;
/* harmony export (immutable) */ __webpack_exports__["requestMarkAsRead"] = requestMarkAsRead;
/* harmony export (immutable) */ __webpack_exports__["requestArchiveThread"] = requestArchiveThread;
/* harmony export (immutable) */ __webpack_exports__["requestTrashThread"] = requestTrashThread;
/* harmony export (immutable) */ __webpack_exports__["requestCreateLabel"] = requestCreateLabel;
/* harmony export (immutable) */ __webpack_exports__["createLabel"] = mailbox_createLabel;
/* harmony export (immutable) */ __webpack_exports__["requestRenameLabel"] = requestRenameLabel;
/* harmony export (immutable) */ __webpack_exports__["renameLabel"] = renameLabel;
/* harmony export (immutable) */ __webpack_exports__["partialSyncMailBox"] = partialSyncMailBox;
/* harmony export (immutable) */ __webpack_exports__["triggerEmailModal"] = triggerEmailModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dataloader__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dataloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dataloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_64__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(41);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var b64Decode = __WEBPACK_IMPORTED_MODULE_2_base_64___default.a.decode;

function moveLabel(lastX, nextX) {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["C" /* MOVE_LABEL */], lastX: lastX, nextX: nextX };
}

function moveCard(lastLabelId, nextLabelId, threadId) {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["B" /* MOVE_CARD */], lastLabelId: lastLabelId, nextLabelId: nextLabelId, threadId: threadId };
}

function toggleDragging(isDragging) {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["S" /* TOGGLE_DRAGGING */], isDragging: isDragging };
}

function getQueryString(params) {
  return Object.keys(params).map(function (k) {
    if (Array.isArray(params[k])) {
      return params[k].map(function (val) {
        return encodeURIComponent(k) + '[]=' + encodeURIComponent(val);
      }).join('&');
    }

    return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
  }).join('&');
}

function sortEmails(emails, labels) {
  var labelsMap = labels.reduce(function (map, obj) {
    map[obj] = [];
    return map;
  }, {});
  for (var idx = 0; idx < emails.length; idx++) {
    var email = emails[idx];
    var formattedEmail = formatEmail(email);
    for (var labelidx = 0; labelidx < email.labelIds.length; labelidx++) {
      var label = email.labelIds[labelidx];
      if (label in labelsMap) {
        labelsMap[label].push(formattedEmail);
      }
    }
  }
  return labelsMap;
}

/**
 * Decodes a url safe Base64 string to its original representation.
 * @param  {string} string
 * @return {string}
 */
function urlB64Decode(string) {
  return string ? decodeURIComponent(escape(b64Decode(string.replace(/\-/g, '+').replace(/\_/g, '/')))) : '';
}

function indexHeaders(headers) {
  if (!headers) {
    return {};
  }
  return headers.reduce(function (result, header) {
    result[header.name.toLowerCase()] = header.value;
    return result;
  }, {});
}

// taken from https://github.com/emiltholin/gmail-api-parse-message

function formatEmail(email) {
  var result = {
    id: email.id,
    snippet: email.snippet,
    threadId: email.threadId,
    labelIds: email.labelIds,
    date: email.internalDate
  };

  var headers = indexHeaders(email.payload.headers);
  result.headers = headers;

  var parts = [email.payload];
  var firstPartProcessed = false;
  while (parts.length !== 0) {
    var part = parts.shift();
    if (part.parts) {
      parts = parts.concat(part.parts);
    }
    if (firstPartProcessed) {
      headers = indexHeaders(part.headers);
    }

    var isHtml = part.mimeType && part.mimeType.indexOf('text/html') !== -1;
    var isPlain = part.mimeType && part.mimeType.indexOf('text/plain') !== -1;
    var isAttachment = headers['content-disposition'] && headers['content-disposition'].indexOf('attachment') !== -1;

    if (isHtml && !isAttachment) {
      result.textHtml = urlB64Decode(part.body.data);
    } else if (isPlain && !isAttachment) {
      result.textPlain = urlB64Decode(part.body.data);
    } else if (isAttachment) {
      var body = part.body;
      if (!result.attachments) {
        result.attachments = [];
      }
      result.attachments.push({
        filename: part.filename,
        mimeType: part.mimeType,
        size: body.size,
        attachmentId: body.attachmentId
      });
    }
    firstPartProcessed = true;
  }
  return result;
}

function processEmails(emails) {
  var inbox = [];
  for (var idx = 0; idx < emails.length; idx++) {
    var email = emails[idx];
    inbox.push(formatEmail(email));
  }
  return inbox;
}

function formatThread(thread) {
  var emails = processEmails(thread.messages);
  var latestEmail = emails[emails.length - 1];
  var unread = false;
  for (var i = 0; i < emails.length; i++) {
    if (emails[i].labelIds.indexOf('UNREAD') > -1) {
      unread = true;
      break;
    }
  }
  return {
    id: thread.id,
    historyId: thread.historyId,
    date: latestEmail.date,
    to: latestEmail.headers.to,
    from: latestEmail.headers.from,
    snippet: latestEmail.snippet,
    subject: latestEmail.headers.subject,
    labelIds: latestEmail.labelIds,
    emails: emails,
    unread: unread
  };
}

function processThreads(threads) {
  var inbox = [];
  for (var idx = 0; idx < threads.length; idx++) {
    var thread = threads[idx];
    inbox.push(formatThread(thread));
  }
  return inbox;
}

function sortAndProcessMessages(messages, labelIds) {
  var messagesTrashed = [];
  var messagesRemovedFromLabels = [];
  var messagesChanged = []; // changed or added
  var messagesDeleted = [];
  for (var i = 0; i < messages.length; i++) {
    if (messages[i].deleted) {
      messagesDeleted.push(messages[i]);
    } else {
      var email = formatEmail(messages[i]);
      if (email.labelIds.indexOf('TRASH') > -1) {
        // deleted messages
        messagesTrashed.push(email);
      } else if (email.labelIds.some(function (v) {
        return labelIds.indexOf(v) >= 0;
      })) {
        messagesChanged.push(email);
      } else {
        messagesRemovedFromLabels.push(email);
      }
    }
  }
  return { messagesTrashed: messagesTrashed, messagesChanged: messagesChanged, messagesRemovedFromLabels: messagesRemovedFromLabels, messagesDeleted: messagesDeleted };
}

function updateLabelsToShow(labels) {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["Y" /* UPDATE_LABELS_TO_SHOW */], labels: labels };
}

function refreshAuth(user, fetch) {
  return refreshToken(user, fetch).then(function (data) {
    var newUser = {
      id: user.id,
      email: user.email,
      accessToken: data.access_token,
      refreshToken: user.refreshToken,
      expiryTime: data.expiryTime
    };
    return newUser;
  });
}

function requestFetchAllLabels() {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["w" /* LIST_ALL_LABELS_REQUEST */] };
}

function mailbox_fetchAllLabels(user) {
  return fetchAllLabels(user);
}

function fullSyncMailBoxLabel(user, labelId) {
  var params = {
    labelIds: labelId
  };

  var queryString = getQueryString(params);
  return fetchThreadIds(user, '?' + queryString).then(function (data) {
    var threadIds = [];
    var threads = data.threads || [];
    for (var i = 0; i < threads.length; i++) {
      threadIds.push(threads[i].id);
    }
    return threadIds;
  }).then(function (threadIds) {
    return fetchManyThreads(user, threadIds);
  }).then(function (threads) {
    return processThreads(threads);
  });
}

// just a wrapper for the gmail fetch
function mailbox_fetchMultipleLabelInfo(user, labelIds) {
  return fetchMultipleLabelInfo(user, labelIds);
}

// just a wrapper for the gmail fetch
function mailbox_fetchLabelInfo(user, labelId) {
  return fetchLabelInfo(user, labelId);
}

function getLatestHistoryId(labelsMap) {
  var historyIds = [];
  for (var key in labelsMap) {
    var threads = labelsMap[key];
    var maxHistoryId = Math.max.apply(Math, _toConsumableArray(threads.map(function (item) {
      return Number(item.historyId);
    })));
    historyIds.push(maxHistoryId);
  }
  return Math.max.apply(Math, historyIds).toString();
}

function fetchFullEmail(user, email) {
  if (email.attachments) {
    var attachmentIds = email.attachments.map(function (a) {
      return a.attachmentId;
    });
    var singleFetch = fetchManyAttachments(user, email.id, attachmentIds);
    return singleFetch.then(function (data) {
      for (var i = 0; i < email.attachments.length; i++) {
        email.attachments[i].size = data[i].size;
        email.attachments[i].data = data[i].data;
      }
      return email;
    });
  }
  return email;
}

function fetchFullEmails(user, emails) {
  var allFetches = [];
  for (var i = 0; i < emails.length; i++) {
    allFetches.push(fetchFullEmail(user, emails[i]));
  }
  return Promise.all(allFetches);
}

// with attachments
function fetchFullThreads(user, threadIds) {
  return fetchManyThreads(user, threadIds).then(function (data) {
    var threadFetches = [];
    var formattedThreads = [];
    for (var i = 0; i < data.length; i++) {
      var thread = data[i];
      var formattedThread = formatThread(thread);
      formattedThreads.push(formattedThread);
      var singleFetch = fetchFullEmails(user, formattedThread.emails);
      // .then(data => {
      //   formattedThread.emails = data;
      //   formattedThreads.push(formattedThread);
      // })
      threadFetches.push(singleFetch);
    }
    return Promise.all(threadFetches).then(function (threadEmails) {
      for (var _i = 0; _i < threadEmails.length; _i++) {
        formattedThreads[_i].emails = threadEmails[_i];
      }
      return formattedThreads;
    });
  });
}

function fullSyncMultipleLabels(user, labelIds) {
  var allFetches = [];
  for (var i = 0; i < labelIds.length; i++) {
    var param = {
      labelIds: labelIds[i]
    };
    var queryString = getQueryString(param);
    var threadFetch = fetchThreadIds(user, '?' + queryString).then(function (data) {
      if (data.threads === undefined) {
        return [];
      }
      var threadIds = [];
      for (var _i2 = 0; _i2 < data.threads.length; _i2++) {
        threadIds.push(data.threads[_i2].id);
      }
      return threadIds;
    }).then(function (threadIds) {
      return fetchManyThreads(user, threadIds);
    });
    // .then(threadIds => fetchFullThreads(user, threadIds))
    allFetches.push(threadFetch);
  }
  return Promise.all(allFetches).then(function (data) {
    var labelsMap = {};
    for (var _i3 = 0; _i3 < data.length; _i3++) {
      labelsMap[labelIds[_i3]] = data[_i3].map(function (thread) {
        return formatThread(thread);
      });
      // labelsMap[labelIds[i]] = data[i];
    }
    return { latestHistoryId: getLatestHistoryId(labelsMap), labelsMap: labelsMap };
  });
}

function syncMailBoxLabel(user, label) {
  return function (dispatch) {
    dispatch({ type: SYNC_MAILBOX_LABEL_START, labelId: label.id });
    return fetchHistory(user, label.latestHistoryId).then(function (data) {});
  };
}

function addLabelToShow() {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ADD_LABEL_TO_SHOW */] };
}

function requestPartialSyncMailBox() {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["H" /* PARTIAL_SYNC_MAILBOX_REQUEST */] };
}

function requestChangeLabelToShow(position, oldLabelId, newLabelId) {
  if (oldLabelId !== newLabelId) {
    return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["f" /* CHANGE_LABEL_TO_SHOW */], position: position, newLabelId: newLabelId };
  }
}

function requestRemoveLabelToShow(position) {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["J" /* REMOVE_LABEL_TO_SHOW */], position: position };
}

function moveThread(user, threadId, labelToAdd, labelToRemove) {
  var labelsToAdd = [labelToAdd];
  var labelsToRemove = [labelToRemove];
  return changeLabels(user, threadId, labelsToAdd, labelsToRemove);
}

function editThreadLabels(user, threadId, labelsToAdd, labelsToRemove) {
  return changeLabels(user, threadId, labelsToAdd, labelsToRemove);
}

function markAsRead(user, threadId) {
  var labelsToAdd = [];
  var labelsToRemove = ['UNREAD'];
  return changeLabels(user, threadId, labelsToAdd, labelsToRemove);
}

function archiveThread(user, threadId, currentThreadId) {
  var labelsToAdd = [];
  var labelsToRemove = ['INBOX', currentThreadId];
  return changeLabels(user, threadId, labelsToAdd, labelsToRemove);
}

function mailbox_trashThread(user, threadId) {
  return trashThread(user, threadId);
}

function requestMarkAsRead(threadId) {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["z" /* MARK_AS_READ_REQUEST */], threadId: threadId };
}

function requestArchiveThread(threadId, currentThreadId) {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ARCHIVE_THREAD_REQUEST */], threadId: threadId, currentThreadId: currentThreadId };
}

function requestTrashThread(threadId) {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["V" /* TRASH_THREAD_REQUEST */], threadId: threadId };
}

function requestCreateLabel(labelName, oldLabelIndex) {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["k" /* CREATE_LABEL_REQUEST */], labelName: labelName, oldLabelIndex: oldLabelIndex };
}

function mailbox_createLabel(user, labelName) {
  var reqBody = {
    name: labelName,
    labelListVisibility: 'labelShow',
    messageListVisibility: 'show'
  };
  return createLabel(user, reqBody);
}

function requestRenameLabel(labelId, newLabelName) {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["N" /* RENAME_LABEL_REQUEST */], labelId: labelId, newLabelName: newLabelName };
}

function renameLabel(user, labelId, newName) {
  var reqBody = {
    id: labelId,
    name: newName
  };
  return modifyLabel(user, labelId, reqBody);
}

function partialSyncMailBox(user, labels, mailbox) {
  // TODO: need to retrieve according to next page token
  // TODO: trigger full sync if fetch history returns 404
  if (!labels.latestHistoryId) {
    return { requestFullSync: true };
  }
  return fetchHistory(user, labels.latestHistoryId).then(function (data) {
    if (data.invalidHistoryId) {
      return { requestFullSync: true };
    }
    if (data.historyId == labels.latestHistoryId) {
      // nothing changed
      return { changed: false };
    }
    if (!data.history) {
      // nothing changed but need to update latestHistoryId
      return { changed: false, latestHistoryId: data.historyId };
    }

    // stuff changed
    var history = data.history;
    var allChangedMessageIds = [];
    for (var i = 0; i < history.length; i++) {
      var changedMessageIds = history[i].messages.map(function (item) {
        return item.id;
      });
      allChangedMessageIds.push.apply(allChangedMessageIds, _toConsumableArray(changedMessageIds));
    }
    // remove duplicates in the list of threadIds
    var allChangedMessageIdsSet = [].concat(_toConsumableArray(new Set(allChangedMessageIds)));
    // fetch and sort, returns a dictionary
    return fetchManyMessages(user, allChangedMessageIdsSet)
    // .then(res => fetchFullEmails(user, res))
    .then(function (messages) {
      var labelIds = Object.keys(mailbox);

      var _sortAndProcessMessag = sortAndProcessMessages(messages, labelIds),
          messagesTrashed = _sortAndProcessMessag.messagesTrashed,
          messagesChanged = _sortAndProcessMessag.messagesChanged,
          messagesRemovedFromLabels = _sortAndProcessMessag.messagesRemovedFromLabels,
          messagesDeleted = _sortAndProcessMessag.messagesDeleted;

      return { changed: true, latestHistoryId: data.historyId, messagesTrashed: messagesTrashed, messagesChanged: messagesChanged, messagesRemovedFromLabels: messagesRemovedFromLabels, messagesDeleted: messagesDeleted };
    });
  });
}

function triggerEmailModal(item, labelId) {
  return { type: __WEBPACK_IMPORTED_MODULE_3__constants__["E" /* OPEN_EMAIL_MODAL */], item: item, labelId: labelId };
}

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */



// Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history
/* harmony default export */ __webpack_exports__["a"] = (true && __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()());

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(229);
module.exports = __webpack_require__(434);


/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CARD_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CARD_MARGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return OFFSET_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return USER_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return USER_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return USER_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return UPDATE_USER_CREDENTIALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FULL_SYNC_MAILBOX_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FULL_SYNC_MAILBOX_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return PARTIAL_SYNC_MAILBOX_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return PARTIAL_SYNC_MAILBOX_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return PARTIAL_SYNC_MAILBOX_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return UPDATE_HISTORY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SYNC_MAILBOX_LABEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SYNC_MAILBOX_LABEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SYNC_MAILBOX_LABEL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return LIST_ALL_LABELS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return LIST_ALL_LABELS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return LIST_ALL_LABELS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_MAILBOX_LABEL_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_MAILBOX_LABEL_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_MAILBOX_LABEL_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return MOVE_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return MOVE_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return TOGGLE_DRAGGING; });
/* unused harmony export GMAIL_UNREAD_SYNC_MS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_ALL_MAILBOX_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_LABEL_TO_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return UPDATE_LABELS_TO_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_LABEL_TO_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHANGE_LABEL_TO_SHOW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return REMOVE_LABEL_TO_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return REMOVE_LABEL_TO_SHOW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return REMOVE_LABEL_TO_SHOW_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return OPEN_EMAIL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLOSE_EMAIL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return MARK_AS_READ_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return MARK_AS_READ_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MARK_AS_READ_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ARCHIVE_THREAD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ARCHIVE_THREAD_SUCCESS; });
/* unused harmony export ARCHIVE_THREAD_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return TRASH_THREAD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return TRASH_THREAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return TRASH_THREAD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CREATE_LABEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CREATE_LABEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CREATE_LABEL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return RENAME_LABEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return RENAME_LABEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return RENAME_LABEL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return TOGGLE_LABEL_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return OPEN_LABEL_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLOSE_LABEL_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EDIT_LABELS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EDIT_LABELS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EDIT_LABELS_FAILURE; });
/* eslint-disable import/prefer-default-export */
var CARD_HEIGHT = 168; // height of a single card(excluding marginBottom/paddingBottom)
var CARD_MARGIN = 32; // height of a marginBottom+paddingBottom
var OFFSET_HEIGHT = 84; // height offset from the top of the page

var USER_LOGOUT = 'USER_LOGOUT';
var USER_LOGIN = 'USER_LOGIN';
var USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
var UPDATE_USER_CREDENTIALS = 'UPDATE_USER_CREDENTIALS';

var FULL_SYNC_MAILBOX_REQUEST = 'FULL_SYNC_MAILBOX_REQUEST';
var FULL_SYNC_MAILBOX_FAILURE = 'FULL_SYNC_MAILBOX_FAILURE';
var PARTIAL_SYNC_MAILBOX_REQUEST = 'PARTIAL_SYNC_MAILBOX_REQUEST';
var PARTIAL_SYNC_MAILBOX_SUCCESS = 'PARTIAL_SYNC_MAILBOX_SUCCESS';
var PARTIAL_SYNC_MAILBOX_FAILURE = 'PARTIAL_SYNC_MAILBOX_FAILURE';
var UPDATE_HISTORY_ID = 'UPDATE_HISTORY_ID';

var SYNC_MAILBOX_LABEL_REQUEST = 'SYNC_MAILBOX_LABEL_REQUEST';
var SYNC_MAILBOX_LABEL_SUCCESS = 'SYNC_MAILBOX_LABEL_SUCCESS';
var SYNC_MAILBOX_LABEL_FAILURE = 'SYNC_MAILBOX_LABEL_FAILURE';

var LIST_ALL_LABELS_REQUEST = 'LIST_ALL_LABELS_REQUEST';
var LIST_ALL_LABELS_SUCCESS = 'LIST_ALL_LABELS_SUCCESS';
var LIST_ALL_LABELS_FAILURE = 'LIST_ALL_LABELS_FAILURE';

var GET_MAILBOX_LABEL_INFO_REQUEST = 'GET_MAILBOX_LABEL_INFO_REQUEST';
var GET_MAILBOX_LABEL_INFO_SUCCESS = 'GET_MAILBOX_LABEL_INFO_SUCCESS';
var GET_MAILBOX_LABEL_INFO_FAILURE = 'GET_MAILBOX_LABEL_INFO_FAILURE';

var MOVE_CARD = 'MOVE_CARD';
var MOVE_LABEL = 'MOVE_LABEL';
var TOGGLE_DRAGGING = 'TOGGLE_DRAGGING';

var GMAIL_UNREAD_SYNC_MS = 10 * 1000; // every 10 seconds
var FETCH_ALL_MAILBOX_LABELS = 30 * 60 * 1000; // every 30 minutes

var ADD_LABEL_TO_SHOW = 'ADD_LABEL_TO_SHOW';
var UPDATE_LABELS_TO_SHOW = 'UPDATE_LABELS_TO_SHOW';
var CHANGE_LABEL_TO_SHOW = 'CHANGE_LABEL_TO_SHOW';
var CHANGE_LABEL_TO_SHOW_SUCCESS = 'CHANGE_LABEL_TO_SHOW_SUCCESS';
var REMOVE_LABEL_TO_SHOW = 'REMOVE_LABEL';
var REMOVE_LABEL_TO_SHOW_SUCCESS = 'REMOVE_LABEL_SUCCESS';
var REMOVE_LABEL_TO_SHOW_FAILURE = 'REMOVE_LABEL_FAILURE';

var OPEN_EMAIL_MODAL = 'OPEN_EMAIL_MODAL';
var CLOSE_EMAIL_MODAL = 'CLOSE_EMAIL_MODAL';

var MARK_AS_READ_REQUEST = 'MARK_AS_READ_REQUEST';
var MARK_AS_READ_SUCCESS = 'MARK_AS_READ';
var MARK_AS_READ_FAILURE = 'MARK_AS_READ_FAILURE';
var ARCHIVE_THREAD_REQUEST = 'ARCHIVE_THREAD_REQUEST';
var ARCHIVE_THREAD_SUCCESS = 'ARCHIVE_THREAD_SUCCESS';
var ARCHIVE_THREAD_FAILURE = 'ARCHIVE_THREAD_FAILURE';
var TRASH_THREAD_REQUEST = 'TRASH_THREAD_REQUEST';
var TRASH_THREAD_SUCCESS = 'TRASH_THREAD_SUCCESS';
var TRASH_THREAD_FAILURE = 'TRASH_THREAD_FAILURE';

var CREATE_LABEL_REQUEST = 'CREATE_LABEL_REQUEST';
var CREATE_LABEL_SUCCESS = 'CREATE_LABEL_SUCCESS';
var CREATE_LABEL_FAILURE = 'CREATE_LABEL_FAILURE';
var RENAME_LABEL_REQUEST = 'RENAME_LABEL_REQUEST';
var RENAME_LABEL_SUCCESS = 'RENAME_LABEL_SUCCESS';
var RENAME_LABEL_FAILURE = 'RENAME_LABEL_FAILURE';

var TOGGLE_LABEL_SELECTOR = 'TOGGLE_LABEL_SELECTOR';
var OPEN_LABEL_SELECTOR = 'OPEN_LABEL_SELECTOR';
var CLOSE_LABEL_SELECTOR = 'CLOSE_LABEL_SELECTOR';

var EDIT_LABELS_REQUEST = 'EDIT_LABELS_REQUEST';
var EDIT_LABELS_SUCCESS = 'EDIT_LABELS_SUCCESS';
var EDIT_LABELS_FAILURE = 'EDIT_LABELS_FAILURE';

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/components/App.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(223);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */





var ContextType = _extends({
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // Universal HTTP client
  fetch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */].childContextTypes);

/**
 * The top-level React component setting context (global) variables
 * that can be accessed from all the child components.
 *
 * https://facebook.github.io/react/docs/context.html
 *
 * Usage example:
 *
 *   const context = {
 *     history: createBrowserHistory(),
 *     store: createStore(),
 *   };
 *
 *   ReactDOM.render(
 *     <App context={context}>
 *       <Layout>
 *         <LandingPage />
 *       </Layout>
 *     </App>,
 *     container,
 *   );
 */

var App = function (_React$PureComponent) {
  _inherits(App, _React$PureComponent);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return this.props.context;
    }
  }, {
    key: 'render',
    value: function render() {
      // NOTE: If you need to add or modify header, footer etc. of the app,
      // please do that inside the Layout component.
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(this.props.children);
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

App.childContextTypes = ContextType;


/* harmony default export */ var App_defaultExport = (App);
// CONCATENATED MODULE: ./src/createFetch.js
var createFetch__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Creates a wrapper function around the HTML5 Fetch API that provides
 * default arguments to fetch(...) and is intended to reduce the amount
 * of boilerplate code in the application.
 * https://developer.mozilla.org/docs/Web/API/Fetch_API/Using_Fetch
 */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

function createFetch(fetch, _ref) {
  var baseUrl = _ref.baseUrl,
      cookie = _ref.cookie;

  // NOTE: Tweak the default options to suite your application needs
  var defaults = {
    method: 'POST', // handy with GraphQL backends
    mode: baseUrl ? 'cors' : 'same-origin',
    credentials: baseUrl ? 'include' : 'same-origin',
    headers: createFetch__extends({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, cookie ? { Cookie: cookie } : null)
  };

  return function (url, options) {
    return url.startsWith('/graphql') || url.startsWith('/api') ? fetch('' + baseUrl + url, createFetch__extends({}, defaults, options, {
      headers: createFetch__extends({}, defaults.headers, options && options.headers)
    })) : fetch(url, options);
  };
}

/* harmony default export */ var createFetch_defaultExport = (createFetch);
// CONCATENATED MODULE: ./src/reducers/user.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(41);



var user_initialState = null;

function user_user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__constants__["Z" /* UPDATE_USER_CREDENTIALS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.user);
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_0" /* USER_LOGIN */]:
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.user);
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_2" /* USER_LOGOUT */]:
      return user_initialState;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_1" /* USER_LOGIN_FAILURE */]:
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/mailbox.js
/* harmony import */ var mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(45);
/* harmony import */ var mailbox___WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var mailbox___WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(41);



function getInsertIndexByDate(array, date) {
  var low = 0,
      high = array.length;

  while (low < high) {
    var mid = low + high >>> 1;
    if (array[mid].date > date) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return low;
}

function findAndRemoveInLabel(removedMessage, label) {
  // find the thread that message belongs to
  var threadIndex = label.threads.findIndex(function (item) {
    return item.id === removedMessage.threadId;
  });
  if (threadIndex === -1) {
    // does not belong to any thread in label: label not affected, return label
    return label;
  }
  var thread = label.threads[threadIndex];
  var indexToRemoveFrom = -1;
  // find message in thread to remove it
  for (var i = 0; i < thread.emails.length; i++) {
    var email = thread.emails[i];
    if (email.id === removedMessage.id) {
      indexToRemoveFrom = i; // this is the index of the email in the thread's list of emails
      break;
    }
  }

  // message not in the thread: label not affected, return label
  if (indexToRemoveFrom === -1) {
    return label;
  }

  // if the message in thread, delete message from thread
  thread.emails.splice(indexToRemoveFrom, 1);

  // if there are no messages remaining in thread, delete thread;
  if (thread.emails.length === 0) {
    label.threads.splice(threadIndex, 1);
    return label;
  }
  // update thread unread flag
  // if the message removed is read, no effect on the unread label of the thread
  if (removedMessage.labelIds.indexOf('UNREAD') > -1) {
    // only need to update flag if message removed is unread
    thread.unread = checkThreadUnread(thread);
  }
  label.threads[threadIndex] = thread;
  return label;
}

function findAndUpdateInLabel(changedMessage, label) {
  var threadId = changedMessage.threadId;
  var threadIndex = label.threads.findIndex(function (item) {
    return item.id === changedMessage.threadId;
  });
  if (threadIndex === -1) {
    // thread doesn't exist, create new thread for message
    // find insertion index
    var insertionIndex = getInsertIndexByDate(label.threads, changedMessage.date);
    var newThread = {
      id: changedMessage.threadId,
      emails: [changedMessage],
      historyId: changedMessage.historyId,
      date: changedMessage.date,
      to: changedMessage.to,
      from: changedMessage.from,
      snippet: changedMessage.snippet,
      content: changedMessage.content,
      subject: changedMessage.subject,
      labelIds: changedMessage.labelIds,
      unread: changedMessage.labelIds.indexOf('UNREAD') > -1
    };
    label.threads.splice(insertionIndex, 0, newThread);
    return label;
  }

  var relevantThread = label.threads[threadIndex];
  var index = relevantThread.emails.findIndex(function (item) {
    return item.id === changedMessage.id;
  });
  if (index === -1) {
    // not in current messages, add to message
    var _insertionIndex = getInsertIndexByDate(relevantThread.emails, changedMessage.date);
    relevantThread.emails.splice(_insertionIndex, 0, changedMessage);
  } else {
    // message already inside, just change
    relevantThread.emails[index] = changedMessage;
  }

  if (changedMessage.labelIds.indexOf('UNREAD') > -1) {
    relevantThread.unread = true;
  } else if (relevantThread.unread) {
    // check if thread is still overall unread, and update accordingly
    relevantThread.unread = checkThreadUnread(relevantThread);
  }
  label.threads[threadIndex] = relevantThread;
  return label;
}

function checkThreadUnread(thread) {
  var unread = false;
  for (var i = 0; i < thread.emails.length; i++) {
    if (thread.emails[i].labelIds.indexOf('UNREAD') > -1) {
      unread = true;
      break;
    }
  }
  return unread;
}

function findThreadById(threadList, threadId) {
  for (var i = 0; i < threadList.length; i++) {
    if (threadList[i].id === threadId) {
      return { threadToMove: threadList[i], lastY: i };
    }
  }
  return { threadToMove: null, lastY: -1 };
}

var mailbox_initialState = new mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["Map"]();

function mailbox_mailbox() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mailbox_initialState;
  var action = arguments[1];

  switch (action.type) {
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["n" /* EDIT_LABELS_REQUEST */]:
      {
        var _jsState = state.toJS();
        var _threadId = action.threadId,
            thread = action.thread,
            labelsToAdd = action.labelsToAdd,
            labelsToRemove = action.labelsToRemove,
            newLabelsList = action.newLabelsList,
            currentBoard = action.currentBoard;

        var currentLabels = Object.keys(_jsState);
        // these are the labels that are in the store that are added to thread
        var toAddOverlap = labelsToAdd.filter(function (x) {
          return currentLabels.indexOf(x) > -1;
        });
        // labels in store that are removed from thread
        var toRemoveOverlap = labelsToRemove.filter(function (x) {
          return currentLabels.indexOf(x) > -1;
        });

        var currentBoards = thread.labelIds.filter(function (x) {
          return currentLabels.indexOf(x) > -1;
        });
        for (var boardIndex = 0; boardIndex < currentBoards.length; boardIndex++) {
          var board = _jsState[currentBoards[boardIndex]];
          for (var threadIdx = 0; threadIdx < board.threads.length; threadIdx++) {
            if (board.threads[threadIdx].id === _threadId) {
              board.threads[threadIdx].labelIds = newLabelsList;
              break;
            }
          }
        }
        if (toAddOverlap.length === 0 && toRemoveOverlap.length === 0) {
          // no change
          // need to change the labels
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(_jsState);
        }
        // only handle add 1 first
        if (toAddOverlap.length === 1) {
          // add this thread to list
          var addLabel = toAddOverlap[0];
          var insertionIndex = getInsertIndexByDate(_jsState[addLabel].threads, thread.date);
          _jsState[addLabel].threads.splice(insertionIndex, 0, thread);
        }
        // only handle remove one first
        if (toRemoveOverlap.length === 1) {
          var removeLabel = toRemoveOverlap[0];
          for (var idx = 0; idx < _jsState[removeLabel].threads.length; idx++) {
            var currentThread = _jsState[removeLabel].threads[idx];
            if (currentThread.id === _threadId) {
              _jsState[removeLabel].threads.splice(idx, 1);
              break;
            }
          }
        }
        return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(_jsState);
      }
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["l" /* CREATE_LABEL_SUCCESS */]:
      {
        var newLabel = action.newLabel;
        var newLabelItem = {
          id: newLabel.id,
          name: newLabel.name,
          type: newLabel.type,
          messagesTotal: newLabel.messagesTotal,
          messagesUnread: newLabel.messagesUnread,
          threadsTotal: newLabel.threadsTotal,
          threadsUnread: newLabel.threadsUnread,
          isFetching: false,
          threads: []
        };
        return state.set(newLabel.id, Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(newLabelItem));
      }
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["O" /* RENAME_LABEL_SUCCESS */]:
      {
        var labelId = action.labelId,
            _newLabel = action.newLabel;

        var newLabelName = _newLabel.name;
        var _jsState2 = state.toJS();
        for (var label in _jsState2) {
          if (_jsState2[label].id === labelId) {
            _jsState2[label].name = _newLabel.name;
            break;
          }
        }
        return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(_jsState2);
      }
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ARCHIVE_THREAD_REQUEST */]:
      {
        var _threadId2 = action.threadId;

        var _jsState3 = state.toJS();
        var spliceId = null;
        for (var lane in _jsState3) {
          var threads = _jsState3[lane].threads;
          for (var i = 0; i < threads.length; i++) {
            var _thread = threads[i];
            if (_thread.id === _threadId2) {
              threads.splice(i, 1);
              break;
            }
          }
        }
        return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(_jsState3);
      }
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["V" /* TRASH_THREAD_REQUEST */]:
      {
        var _threadId3 = action.threadId;

        var _jsState4 = state.toJS();
        var _spliceId = null;
        for (var lane in _jsState4) {
          var _threads = _jsState4[lane].threads;
          for (var i = 0; i < _threads.length; i++) {
            var _thread2 = _threads[i];
            if (_thread2.id === _threadId3) {
              _threads.splice(i, 1);
              break;
            }
          }
        }
        return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(_jsState4);
      }
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["z" /* MARK_AS_READ_REQUEST */]:
      var threadId = action.threadId;

      var jsState = state.toJS();
      for (var lane in jsState) {
        var _threads2 = jsState[lane].threads;
        for (var i = 0; i < _threads2.length; i++) {
          var _thread3 = _threads2[i];
          if (_thread3.id === threadId) {
            _thread3.unread = false;
            break;
          }
        }
      }
      // return state;
      return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(jsState);
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["B" /* MOVE_CARD */]:
      {
        var lastLabelId = action.lastLabelId,
            nextLabelId = action.nextLabelId,
            _threadId4 = action.threadId;

        if (lastLabelId === nextLabelId) {
          return state;
        }
        var lastLabel = state.toJS()[lastLabelId];
        var nextLabel = state.toJS()[nextLabelId];

        var nextLane = nextLabel.threads;
        var lastLane = lastLabel.threads;

        // move element to new place

        var _findThreadById = findThreadById(lastLane, _threadId4),
            threadToMove = _findThreadById.threadToMove,
            lastY = _findThreadById.lastY;

        var _insertionIndex2 = getInsertIndexByDate(nextLane, threadToMove.date);

        // remove label from element and add new one
        var threadLabels = threadToMove.labelIds;
        var index = threadLabels.indexOf(lastLabelId);
        if (index > -1) {
          threadLabels.splice(index, 1);
        }
        threadLabels.push(nextLabelId);
        threadToMove.labelIds = threadLabels;

        // TODO: need to remove and add label to each email as well

        nextLane.splice(_insertionIndex2, 0, threadToMove);
        // delete element from old place
        lastLane.splice(lastY, 1);
        return state.withMutations(function (ctx) {
          ctx.setIn([lastLabelId, 'threads'], Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(lastLane));
          ctx.setIn([lastLabelId, 'messagesTotal'], lastLabel.messagesTotal - 1);
          ctx.setIn([nextLabelId, 'threads'], Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(nextLane));
          ctx.setIn([nextLabelId, 'messagesTotal'], nextLabel.messagesTotal + 1);
        });
      }
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["Q" /* SYNC_MAILBOX_LABEL_REQUEST */]:
      return state.setIn([action.labelId, 'isFetching'], true);
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["P" /* SYNC_MAILBOX_LABEL_FAILURE */]:
      return state.setIn([action.labelId, 'isFetching'], false);
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["R" /* SYNC_MAILBOX_LABEL_SUCCESS */]:
      {
        if (!action.threads) {
          return state.withMutations(function (ctx) {
            ctx.setIn([action.labelId, 'isFetching'], false);
          });
        }

        if (action.latestUnreadThreads) {
          return state.withMutations(function (ctx) {
            ctx.setIn([action.labelId, 'isFetching'], false);
            ctx.setIn([action.labelId, 'threads'], Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.threads));
            ctx.setIn([action.labelId, 'latestUnreadThreads'], Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.latestUnreadThreads));
          });
        }
        return state.withMutations(function (ctx) {
          ctx.setIn([action.labelId, 'isFetching'], false);
          ctx.setIn([action.labelId, 'threads'], Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.threads));
        });
      }
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["t" /* GET_MAILBOX_LABEL_INFO_REQUEST */]:
      return state.setIn([action.labelId, 'isFetching'], true);
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["s" /* GET_MAILBOX_LABEL_INFO_FAILURE */]:
      return state.setIn([action.labelId, 'isFetching'], false);
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["u" /* GET_MAILBOX_LABEL_INFO_SUCCESS */]:
      {
        if (!action.payload) {
          return state.setIn([action.labelId, 'isFetching'], false);
        }
        if (action.payload.latestUnreadThreads) {
          return state.withMutations(function (ctx) {
            ctx.setIn([action.labelId, 'id'], action.payload.id).setIn([action.labelId, 'name'], action.payload.name).setIn([action.labelId, 'type'], action.payload.type).setIn([action.labelId, 'messagesTotal'], action.payload.messagesTotal).setIn([action.labelId, 'messagesUnread'], action.payload.messagesUnread).setIn([action.labelId, 'threadsTotal'], action.payload.threadsTotal).setIn([action.labelId, 'threadsUnread'], action.payload.threadsUnread).setIn([action.labelId, 'isFetching'], false).setIn([action.labelId, 'latestUnreadThreads'], action.payload.latestUnreadThreads);
          });
        }
        return state.withMutations(function (ctx) {
          ctx.setIn([action.labelId, 'id'], action.payload.id).setIn([action.labelId, 'name'], action.payload.name).setIn([action.labelId, 'type'], action.payload.type).setIn([action.labelId, 'messagesTotal'], action.payload.messagesTotal).setIn([action.labelId, 'messagesUnread'], action.payload.messagesUnread).setIn([action.labelId, 'threadsTotal'], action.payload.threadsTotal).setIn([action.labelId, 'threadsUnread'], action.payload.threadsUnread).setIn([action.labelId, 'isFetching'], false);
        });
      }
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["H" /* PARTIAL_SYNC_MAILBOX_REQUEST */]:
      return state;
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["I" /* PARTIAL_SYNC_MAILBOX_SUCCESS */]:
      {
        if (!action.changed) {
          return state;
        }
        var _jsState5 = state.toJS();
        var labelIds = Object.keys(_jsState5);
        // update changed messages
        for (var i = 0; i < action.messagesChanged.length; i++) {
          var changedMessage = action.messagesChanged[i];
          for (var idx = 0; idx < labelIds.length; idx++) {
            var _labelId = labelIds[idx];
            if (changedMessage.labelIds.indexOf(_labelId) > -1) {
              // find it in the relevant thread in the label and change it
              var _newLabel2 = findAndUpdateInLabel(changedMessage, _jsState5[_labelId]);
              _jsState5[_labelId] = _newLabel2;
            }
          }
        }
        // update removed messages
        for (var i = 0; i < action.messagesRemovedFromLabels.length; i++) {
          var removedMessage = action.messagesRemovedFromLabels[i];
          for (var idx = 0; idx < labelIds.length; idx++) {
            var _labelId2 = labelIds[idx];
            var _newLabel3 = findAndRemoveInLabel(removedMessage, _jsState5[_labelId2]);
            _jsState5[_labelId2] = _newLabel3;
          }
        }

        // TODO: if trash is one of the labels shown, then need to do something else
        // a message with trash should only appear in trash label and not in other labels, even if there are other labels present
        if (labelIds.indexOf('TRASH') === -1) {
          // if trash is not one of the labels to show, do the same thing as messagesRemovedFromLabels
          for (var i = 0; i < action.messagesTrashed.length; i++) {
            var trashedMessage = action.messagesTrashed[i];
            for (var idx = 0; idx < labelIds.length; idx++) {
              var _labelId3 = labelIds[idx];
              var _newLabel4 = findAndRemoveInLabel(trashedMessage, _jsState5[_labelId3]);
              _jsState5[_labelId3] = _newLabel4;
            }
          }
        }

        // messages that are completely deleted (even in trash), same procedure as removedMessages
        for (var i = 0; i < action.messagesDeleted.length; i++) {
          var deletedMessage = action.messagesDeleted[i];
          for (var idx = 0; idx < labelIds.length; idx++) {
            var _labelId4 = labelIds[idx];
            var _newLabel5 = findAndRemoveInLabel(deletedMessage, _jsState5[_labelId4]);
            _jsState5[_labelId4] = _newLabel5;
          }
        }

        return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(_jsState5);
      }
    case mailbox___WEBPACK_IMPORTED_MODULE_1__constants__["G" /* PARTIAL_SYNC_MAILBOX_FAILURE */]:
      return state;
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/labels.js
/* harmony import */ var labels___WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(45);
/* harmony import */ var labels___WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(labels___WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var labels___WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(41);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var labels_initialState = Object(labels___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
  allLabels: [],
  isFetching: false,
  isDragging: false,
  labelsToShow: []
});
/* eslint-enable new-cap */
// const initialState = new InitialState;
function labels_labels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : labels_initialState;
  var action = arguments[1];

  switch (action.type) {
    case labels___WEBPACK_IMPORTED_MODULE_1__constants__["l" /* CREATE_LABEL_SUCCESS */]:
      {
        var jsState = state.toJS();
        jsState.allLabels.push(action.newLabel);
        jsState.labelsToShow.splice(action.oldLabelIndex + 1, 0, action.newLabel.id);
        return Object(labels___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(jsState);
      }
    case labels___WEBPACK_IMPORTED_MODULE_1__constants__["L" /* REMOVE_LABEL_TO_SHOW_SUCCESS */]:
      {
        var labelsToShow = state.toJS().labelsToShow;
        labelsToShow.splice(action.position, 1);
        return state.set('labelsToShow', Object(labels___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(labelsToShow));
      }
    case labels___WEBPACK_IMPORTED_MODULE_1__constants__["g" /* CHANGE_LABEL_TO_SHOW_SUCCESS */]:
      {
        var _labelsToShow = state.toJS().labelsToShow;
        _labelsToShow[action.position] = action.newLabelId;
        return state.set('labelsToShow', Object(labels___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(_labelsToShow));
      }
    case labels___WEBPACK_IMPORTED_MODULE_1__constants__["Y" /* UPDATE_LABELS_TO_SHOW */]:
      return state.set('labelsToShow', Object(labels___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.labels));
    case labels___WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ADD_LABEL_TO_SHOW */]:
      {
        var newLabelsToShow = state.toJS().labelsToShow;
        if (newLabelsToShow.length !== 0) {
          newLabelsToShow.push(newLabelsToShow[0]);
        } else {
          newLabelsToShow.push('INBOX');
        }
        return state.set('labelsToShow', Object(labels___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(newLabelsToShow));
      }
    case labels___WEBPACK_IMPORTED_MODULE_1__constants__["w" /* LIST_ALL_LABELS_REQUEST */]:
      return state;
    case labels___WEBPACK_IMPORTED_MODULE_1__constants__["x" /* LIST_ALL_LABELS_SUCCESS */]:
      return state.set('allLabels', Object(labels___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.labels));
    case labels___WEBPACK_IMPORTED_MODULE_1__constants__["v" /* LIST_ALL_LABELS_FAILURE */]:
      return state;
    case labels___WEBPACK_IMPORTED_MODULE_1__constants__["X" /* UPDATE_HISTORY_ID */]:
      {
        var currentHistoryId = state.toJS().latestHistoryId || '';
        if (action.latestHistoryId > currentHistoryId) {
          return state.set('latestHistoryId', action.latestHistoryId);
        } else {
          return state;
        }
      }
    case labels___WEBPACK_IMPORTED_MODULE_1__constants__["C" /* MOVE_LABEL */]:
      {
        var _newLabelsToShow = [].concat(_toConsumableArray(state.toJS().labelsToShow));
        var lastX = action.lastX,
            nextX = action.nextX;

        var t = _newLabelsToShow.splice(lastX, 1)[0];

        _newLabelsToShow.splice(nextX, 0, t);

        return state.withMutations(function (ctx) {
          ctx.set('labelsToShow', Object(labels___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(_newLabelsToShow));
        });
      }
    case labels___WEBPACK_IMPORTED_MODULE_1__constants__["S" /* TOGGLE_DRAGGING */]:
      {
        return state.set('isDragging', action.isDragging);
      }
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/modal.js
/* harmony import */ var modal___WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(45);
/* harmony import */ var modal___WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(modal___WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var modal___WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(41);



var modal_initialState = Object(modal___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
  isOpen: false,
  showing: null,
  item: null
});

function modal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : modal_initialState;
  var action = arguments[1];

  switch (action.type) {
    case modal___WEBPACK_IMPORTED_MODULE_1__constants__["E" /* OPEN_EMAIL_MODAL */]:
      {
        return state.withMutations(function (ctx) {
          ctx.set('isOpen', true);
          ctx.set('showing', 'email');
          ctx.set('item', Object(modal___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.item));
          ctx.set('labelId', action.labelId);
        });
      }
    case modal___WEBPACK_IMPORTED_MODULE_1__constants__["h" /* CLOSE_EMAIL_MODAL */]:
      {
        return state.withMutations(function (ctx) {
          ctx.set('isOpen', false);
          ctx.set('showing', null);
          ctx.set('item', null);
        });
      }
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/labelSelector.js
/* harmony import */ var labelSelector___WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(45);
/* harmony import */ var labelSelector___WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(labelSelector___WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var labelSelector___WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(41);



var labelSelector_initialState = Object(labelSelector___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
  isOpen: false,
  threadId: null,
  thread: null,
  currentBoard: null,
  x: null,
  y: null,
  selectedLabels: null
});

function labelSelector() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : labelSelector_initialState;
  var action = arguments[1];

  switch (action.type) {
    case labelSelector___WEBPACK_IMPORTED_MODULE_1__constants__["T" /* TOGGLE_LABEL_SELECTOR */]:
      {
        if (state.toJS().isOpen === false) {
          return state.withMutations(function (ctx) {
            ctx.set('isOpen', true);
            ctx.set('threadId', action.threadId);
            ctx.set('thread', action.thread);
            ctx.set('currentBoard', action.currentBoard);
            ctx.set('x', action.x);
            ctx.set('y', action.y);
            ctx.set('selectedLabels', Object(labelSelector___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.selectedLabels));
          });
        } else {
          return labelSelector_initialState;
        }
      }
    case labelSelector___WEBPACK_IMPORTED_MODULE_1__constants__["F" /* OPEN_LABEL_SELECTOR */]:
      {
        return state.withMutations(function (ctx) {
          ctx.set('isOpen', true);
          ctx.set('threadId', action.threadId);
          ctx.set('thread', action.thread);
          ctx.set('currentBoard', action.currentBoard);
          ctx.set('x', action.x);
          ctx.set('y', action.y);
          ctx.set('selectedLabels', Object(labelSelector___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.selectedLabels));
        });
      }
    case labelSelector___WEBPACK_IMPORTED_MODULE_1__constants__["E" /* OPEN_EMAIL_MODAL */]:
      return labelSelector_initialState;
    case labelSelector___WEBPACK_IMPORTED_MODULE_1__constants__["i" /* CLOSE_LABEL_SELECTOR */]:
      return labelSelector_initialState;
    case labelSelector___WEBPACK_IMPORTED_MODULE_1__constants__["n" /* EDIT_LABELS_REQUEST */]:
      {
        // remove labels first before adding
        return state.set('selectedLabels', Object(labelSelector___WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.newLabelsList));
      }
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);







/* harmony default export */ var reducers_defaultExport = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  user: user_user,
  labels: labels_labels,
  mailbox: mailbox_mailbox,
  modal: modal,
  labelSelector: labelSelector
}));
// CONCATENATED MODULE: ./src/store/createHelpers.js
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function createGraphqlRequest(fetch) {
  return function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(query, variables) {
      var fetchConfig, resp;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fetchConfig = {
                method: 'post',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ query: query, variables: variables }),
                credentials: 'include'
              };
              _context.next = 3;
              return fetch('/graphql', fetchConfig);

            case 3:
              resp = _context.sent;

              if (!(resp.status !== 200)) {
                _context.next = 6;
                break;
              }

              throw new Error(resp.statusText);

            case 6:
              return _context.abrupt('return', resp.json());

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function graphqlRequest(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return graphqlRequest;
  }();
}

function createHelpers(_ref2) {
  var fetch = _ref2.fetch,
      history = _ref2.history;

  return {
    fetch: fetch,
    history: history,
    graphqlRequest: createGraphqlRequest(fetch)
  };
}
// CONCATENATED MODULE: ./src/store/logger/logger.client.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_logger__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_logger__);


function logger_client_createLogger() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_redux_logger__["createLogger"])({
    collapsed: true
  });
}
// CONCATENATED MODULE: ./src/sagas/selectors.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(77);


var getLabels = function getLabels(state) {
  return state.toJS().labels;
};
var getLabelIds = function getLabelIds(state) {
  return state.toJS().labels.labelsToShow;
};
var getUser = function getUser(state) {
  return state.toJS().user;
};
var getMailBox = function getMailBox(state) {
  return state.toJS().mailbox;
};
// CONCATENATED MODULE: ./src/sagas/user.js
/* harmony import */ var user___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_mailbox__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(41);
var _marked = [watchAuth].map(regeneratorRuntime.mark);







function watchAuth(_ref) {
  var fetch = _ref.fetch;

  var user, _ref2, expired, newUser;

  return regeneratorRuntime.wrap(function watchAuth$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (false) {
            _context.next = 33;
            break;
          }

          _context.prev = 1;
          _context.next = 4;
          return Object(user___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 4:
          user = _context.sent;

          if (!(!user || !user.accessToken)) {
            _context.next = 8;
            break;
          }

          _context.next = 8;
          return Object(user___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* take */])(__WEBPACK_IMPORTED_MODULE_4__constants__["_0" /* USER_LOGIN */]);

        case 8:
          _context.next = 10;
          return Object(user___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 10:
          user = _context.sent;
          _context.next = 13;
          return Object(user___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* race */])({
            logout: Object(user___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* take */])(__WEBPACK_IMPORTED_MODULE_4__constants__["_2" /* USER_LOGOUT */]),
            expired: Object(user___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */], user.expiryTime - (new Date().getTime() - 60 * 1000))
          });

        case 13:
          _ref2 = _context.sent;
          expired = _ref2.expired;

          if (expired) {
            _context.next = 19;
            break;
          }

          Object(user___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(fetch, '/logout', { method: 'POST', redirect: 'follow', credentials: 'same-origin' });
          _context.next = 24;
          break;

        case 19:
          _context.next = 21;
          return Object(user___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["refreshAuth"], user, fetch);

        case 21:
          newUser = _context.sent;
          _context.next = 24;
          return Object(user___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_4__constants__["Z" /* UPDATE_USER_CREDENTIALS */], user: newUser });

        case 24:
          _context.next = 31;
          break;

        case 26:
          _context.prev = 26;
          _context.t0 = _context['catch'](1);

          console.log(_context.t0);
          _context.next = 31;
          return Object(user___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_4__constants__["_1" /* USER_LOGIN_FAILURE */] });

        case 31:
          _context.next = 0;
          break;

        case 33:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[1, 26]]);
}
// CONCATENATED MODULE: ./src/sagas/mailbox.js
/* harmony import */ var mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(77);
/* harmony import */ var mailbox___WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(41);
/* harmony import */ var mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__ = __webpack_require__(150);
var mailbox__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var mailbox__marked = [fetchAllLabels, partialSyncMailBox, fullSyncMailBox, watchFullSyncMailBox, watchPartialSyncMailBox, watchFetchAllLabels, addLabelToShow, removeLabelToShow, changeLabelToShow, moveThread, moveLabelToShow, markAsRead, archiveThread, trashThread, renameLabel, editLabels, createLabel, watchAddLabelToShow, watchChangeLabel, watchRemoveLabel, watchMoveLabel, watchMoveThread, watchMarkAsRead, watchArchiveThread, watchTrashThread, watchCreateLabel, watchRenameLabel, watchEditLabels].map(regeneratorRuntime.mark);







function fetchAllLabels(action) {
  var user, data;
  return regeneratorRuntime.wrap(function fetchAllLabels$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 3:
          user = _context.sent;
          _context.next = 6;
          return mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["fetchAllLabels"](user);

        case 6:
          data = _context.sent;

          if (!(data.labels === undefined)) {
            _context.next = 13;
            break;
          }

          console.log(data);
          _context.next = 11;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* LIST_ALL_LABELS_FAILURE */] });

        case 11:
          _context.next = 15;
          break;

        case 13:
          _context.next = 15;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["x" /* LIST_ALL_LABELS_SUCCESS */], labels: data.labels });

        case 15:
          _context.next = 21;
          break;

        case 17:
          _context.prev = 17;
          _context.t0 = _context['catch'](0);
          _context.next = 21;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* LIST_ALL_LABELS_FAILURE */] });

        case 21:
        case 'end':
          return _context.stop();
      }
    }
  }, mailbox__marked[0], this, [[0, 17]]);
}

function partialSyncMailBox(action) {
  var user, mailbox, labels, data;
  return regeneratorRuntime.wrap(function partialSyncMailBox$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 3:
          user = _context2.sent;
          _context2.next = 6;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getMailBox);

        case 6:
          mailbox = _context2.sent;
          _context2.next = 9;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getLabels);

        case 9:
          labels = _context2.sent;
          _context2.next = 12;
          return mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["partialSyncMailBox"](user, labels, mailbox);

        case 12:
          data = _context2.sent;

          if (!data.requestFullSync) {
            _context2.next = 20;
            break;
          }

          _context2.next = 16;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["G" /* PARTIAL_SYNC_MAILBOX_FAILURE */], error: 'Invalid History ID, full sync needed' });

        case 16:
          _context2.next = 18;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* FULL_SYNC_MAILBOX_REQUEST */] });

        case 18:
          _context2.next = 24;
          break;

        case 20:
          _context2.next = 22;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(mailbox__extends({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["I" /* PARTIAL_SYNC_MAILBOX_SUCCESS */] }, data));

        case 22:
          _context2.next = 24;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["X" /* UPDATE_HISTORY_ID */], latestHistoryId: data.latestHistoryId });

        case 24:
          _context2.next = 31;
          break;

        case 26:
          _context2.prev = 26;
          _context2.t0 = _context2['catch'](0);

          console.log(_context2.t0);
          _context2.next = 31;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["q" /* FULL_SYNC_MAILBOX_FAILURE */], error: _context2.t0 });

        case 31:
        case 'end':
          return _context2.stop();
      }
    }
  }, mailbox__marked[1], this, [[0, 26]]);
}

function fullSyncMailBox(action) {
  var tempLabels, user, labelsToShow, labelsInfo, i, labelInfo, _ref, latestHistoryId, labelsMap, key;

  return regeneratorRuntime.wrap(function fullSyncMailBox$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getLabelIds);

        case 3:
          tempLabels = _context3.sent;
          _context3.next = 6;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 6:
          user = _context3.sent;

          // remove duplicates
          labelsToShow = tempLabels.filter(function (elem, index, self) {
            return index === self.indexOf(elem);
          });

          // get label info

          _context3.next = 10;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["fetchMultipleLabelInfo"], user, labelsToShow);

        case 10:
          labelsInfo = _context3.sent;
          i = 0;

        case 12:
          if (!(i < labelsInfo.length)) {
            _context3.next = 19;
            break;
          }

          labelInfo = labelsInfo[i];
          _context3.next = 16;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* GET_MAILBOX_LABEL_INFO_SUCCESS */], labelId: labelInfo.id, payload: labelInfo });

        case 16:
          i++;
          _context3.next = 12;
          break;

        case 19:
          _context3.next = 21;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["fullSyncMultipleLabels"], user, labelsToShow);

        case 21:
          _ref = _context3.sent;
          latestHistoryId = _ref.latestHistoryId;
          labelsMap = _ref.labelsMap;
          _context3.t0 = regeneratorRuntime.keys(labelsMap);

        case 25:
          if ((_context3.t1 = _context3.t0()).done) {
            _context3.next = 31;
            break;
          }

          key = _context3.t1.value;
          _context3.next = 29;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["R" /* SYNC_MAILBOX_LABEL_SUCCESS */], labelId: key, threads: labelsMap[key] });

        case 29:
          _context3.next = 25;
          break;

        case 31:
          _context3.next = 33;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["X" /* UPDATE_HISTORY_ID */], latestHistoryId: latestHistoryId });

        case 33:
          _context3.next = 40;
          break;

        case 35:
          _context3.prev = 35;
          _context3.t2 = _context3['catch'](0);

          console.log(_context3.t2);
          _context3.next = 40;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["q" /* FULL_SYNC_MAILBOX_FAILURE */] });

        case 40:
        case 'end':
          return _context3.stop();
      }
    }
  }, mailbox__marked[2], this, [[0, 35]]);
}

function watchFullSyncMailBox() {
  return regeneratorRuntime.wrap(function watchFullSyncMailBox$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["h" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__constants__["r" /* FULL_SYNC_MAILBOX_REQUEST */], fullSyncMailBox);

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, mailbox__marked[3], this);
}

function watchPartialSyncMailBox() {
  return regeneratorRuntime.wrap(function watchPartialSyncMailBox$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["h" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__constants__["H" /* PARTIAL_SYNC_MAILBOX_REQUEST */], partialSyncMailBox);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, mailbox__marked[4], this);
}

function watchFetchAllLabels() {
  return regeneratorRuntime.wrap(function watchFetchAllLabels$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["h" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__constants__["w" /* LIST_ALL_LABELS_REQUEST */], fetchAllLabels);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, mailbox__marked[5], this);
}

function addLabelToShow() {
  var labelIds, id, position, opts, res;
  return regeneratorRuntime.wrap(function addLabelToShow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getLabelIds);

        case 3:
          labelIds = _context7.sent;
          id = labelIds[labelIds.length - 1];
          position = labelIds.length - 1;
          opts = {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ labelId: id, position: position }) };
          _context7.next = 9;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(fetch, '/api/add-label', opts);

        case 9:
          res = _context7.sent;

          if (!(res.status === 200)) {
            console.log(res.statusText);
          }
          _context7.next = 16;
          break;

        case 13:
          _context7.prev = 13;
          _context7.t0 = _context7['catch'](0);

          console.log(_context7.t0);

        case 16:
        case 'end':
          return _context7.stop();
      }
    }
  }, mailbox__marked[6], this, [[0, 13]]);
}

function removeLabelToShow(action) {
  var opts, res;
  return regeneratorRuntime.wrap(function removeLabelToShow$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          opts = {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ position: action.position })
          };
          _context8.next = 4;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(fetch, '/api/remove-label', opts);

        case 4:
          res = _context8.sent;

          if (!(res.status === 200)) {
            _context8.next = 10;
            break;
          }

          _context8.next = 8;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["L" /* REMOVE_LABEL_TO_SHOW_SUCCESS */], position: action.position });

        case 8:
          _context8.next = 13;
          break;

        case 10:
          console.log(res.statusText);
          _context8.next = 13;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["K" /* REMOVE_LABEL_TO_SHOW_FAILURE */] });

        case 13:
          _context8.next = 20;
          break;

        case 15:
          _context8.prev = 15;
          _context8.t0 = _context8['catch'](0);

          console.log(_context8.t0);
          _context8.next = 20;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["K" /* REMOVE_LABEL_TO_SHOW_FAILURE */] });

        case 20:
        case 'end':
          return _context8.stop();
      }
    }
  }, mailbox__marked[7], this, [[0, 15]]);
}

function changeLabelToShow(action) {
  var user, mailbox, labelId, labelInfo, threads, opts, res;
  return regeneratorRuntime.wrap(function changeLabelToShow$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 3:
          user = _context9.sent;
          _context9.next = 6;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getMailBox);

        case 6:
          mailbox = _context9.sent;
          labelId = action.newLabelId;
          // check if already loaded

          if (!(Object.keys(mailbox).indexOf(labelId) === -1)) {
            _context9.next = 19;
            break;
          }

          _context9.next = 11;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["fetchLabelInfo"], user, labelId);

        case 11:
          labelInfo = _context9.sent;
          _context9.next = 14;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* GET_MAILBOX_LABEL_INFO_SUCCESS */], labelId: labelInfo.id, payload: labelInfo });

        case 14:
          _context9.next = 16;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["fullSyncMailBoxLabel"], user, labelId);

        case 16:
          threads = _context9.sent;
          _context9.next = 19;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["R" /* SYNC_MAILBOX_LABEL_SUCCESS */], labelId: labelId, threads: threads });

        case 19:
          _context9.next = 21;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["H" /* PARTIAL_SYNC_MAILBOX_REQUEST */] });

        case 21:
          // update database
          opts = {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ position: action.position, newLabelId: action.newLabelId })
          };
          _context9.next = 24;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(fetch, '/api/change-label', opts);

        case 24:
          res = _context9.sent;

          if (!(res.status === 200)) {
            _context9.next = 30;
            break;
          }

          _context9.next = 28;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* CHANGE_LABEL_TO_SHOW_SUCCESS */], position: action.position, newLabelId: action.newLabelId });

        case 28:
          _context9.next = 31;
          break;

        case 30:
          console.log(res.statusText);

        case 31:
          _context9.next = 36;
          break;

        case 33:
          _context9.prev = 33;
          _context9.t0 = _context9['catch'](0);

          console.log(_context9.t0);

        case 36:
        case 'end':
          return _context9.stop();
      }
    }
  }, mailbox__marked[8], this, [[0, 33]]);
}

function moveThread(action) {
  var user, data;
  return regeneratorRuntime.wrap(function moveThread$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 3:
          user = _context10.sent;
          _context10.next = 6;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["H" /* PARTIAL_SYNC_MAILBOX_REQUEST */] });

        case 6:
          _context10.next = 8;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["moveThread"], user, action.threadId, action.nextLabelId, action.lastLabelId);

        case 8:
          data = _context10.sent;

          console.log(data);
          _context10.next = 15;
          break;

        case 12:
          _context10.prev = 12;
          _context10.t0 = _context10['catch'](0);

          console.log(_context10.t0);

        case 15:
        case 'end':
          return _context10.stop();
      }
    }
  }, mailbox__marked[9], this, [[0, 12]]);
}

function moveLabelToShow(action) {
  var opts;
  return regeneratorRuntime.wrap(function moveLabelToShow$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          opts = {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ oldPos: action.lastX, newPos: action.nextX })
          };
          _context11.next = 4;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(fetch, '/api/move-label', opts);

        case 4:
          _context11.next = 9;
          break;

        case 6:
          _context11.prev = 6;
          _context11.t0 = _context11['catch'](0);

          console.log(_context11.t0);

        case 9:
        case 'end':
          return _context11.stop();
      }
    }
  }, mailbox__marked[10], this, [[0, 6]]);
}

function markAsRead(action) {
  var user, res;
  return regeneratorRuntime.wrap(function markAsRead$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 3:
          user = _context12.sent;
          _context12.next = 6;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["markAsRead"], user, action.threadId);

        case 6:
          res = _context12.sent;
          _context12.next = 9;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["A" /* MARK_AS_READ_SUCCESS */] });

        case 9:
          _context12.next = 11;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["H" /* PARTIAL_SYNC_MAILBOX_REQUEST */] });

        case 11:
          _context12.next = 18;
          break;

        case 13:
          _context12.prev = 13;
          _context12.t0 = _context12['catch'](0);

          console.log(_context12.t0);
          _context12.next = 18;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* MARK_AS_READ_FAILURE */] });

        case 18:
        case 'end':
          return _context12.stop();
      }
    }
  }, mailbox__marked[11], this, [[0, 13]]);
}

function archiveThread(action) {
  var user, res;
  return regeneratorRuntime.wrap(function archiveThread$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _context13.next = 3;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 3:
          user = _context13.sent;
          _context13.next = 6;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["archiveThread"], user, action.threadId, action.currentThreadId);

        case 6:
          res = _context13.sent;
          _context13.next = 9;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* ARCHIVE_THREAD_SUCCESS */] });

        case 9:
          _context13.next = 11;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["H" /* PARTIAL_SYNC_MAILBOX_REQUEST */] });

        case 11:
          _context13.next = 18;
          break;

        case 13:
          _context13.prev = 13;
          _context13.t0 = _context13['catch'](0);

          console.log(_context13.t0);
          _context13.next = 18;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* ARCHIVE_THREAD_SUCCESS */] });

        case 18:
        case 'end':
          return _context13.stop();
      }
    }
  }, mailbox__marked[12], this, [[0, 13]]);
}

function trashThread(action) {
  var user, res;
  return regeneratorRuntime.wrap(function trashThread$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 3:
          user = _context14.sent;
          _context14.next = 6;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["trashThread"], user, action.threadId);

        case 6:
          res = _context14.sent;
          _context14.next = 9;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["W" /* TRASH_THREAD_SUCCESS */] });

        case 9:
          _context14.next = 11;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["H" /* PARTIAL_SYNC_MAILBOX_REQUEST */] });

        case 11:
          _context14.next = 18;
          break;

        case 13:
          _context14.prev = 13;
          _context14.t0 = _context14['catch'](0);

          console.log(_context14.t0);
          _context14.next = 18;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["U" /* TRASH_THREAD_FAILURE */] });

        case 18:
        case 'end':
          return _context14.stop();
      }
    }
  }, mailbox__marked[13], this, [[0, 13]]);
}

function renameLabel(action) {
  var user, res;
  return regeneratorRuntime.wrap(function renameLabel$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 3:
          user = _context15.sent;
          _context15.next = 6;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["renameLabel"], user, action.labelId, action.newLabelName);

        case 6:
          res = _context15.sent;

          console.log(res);

          if (!res.error) {
            _context15.next = 13;
            break;
          }

          _context15.next = 11;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["M" /* RENAME_LABEL_FAILURE */] });

        case 11:
          _context15.next = 15;
          break;

        case 13:
          _context15.next = 15;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["O" /* RENAME_LABEL_SUCCESS */], labelId: action.labelId, newLabel: res });

        case 15:
          _context15.next = 22;
          break;

        case 17:
          _context15.prev = 17;
          _context15.t0 = _context15['catch'](0);

          console.log(_context15.t0);
          _context15.next = 22;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["M" /* RENAME_LABEL_FAILURE */] });

        case 22:
        case 'end':
          return _context15.stop();
      }
    }
  }, mailbox__marked[14], this, [[0, 17]]);
}

function editLabels(action) {
  var user, res;
  return regeneratorRuntime.wrap(function editLabels$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          _context16.next = 3;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 3:
          user = _context16.sent;
          _context16.next = 6;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["editThreadLabels"], user, action.threadId, action.labelsToAdd, action.labelsToRemove);

        case 6:
          res = _context16.sent;
          _context16.next = 9;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["o" /* EDIT_LABELS_SUCCESS */] });

        case 9:
          _context16.next = 16;
          break;

        case 11:
          _context16.prev = 11;
          _context16.t0 = _context16['catch'](0);

          console.log(_context16.t0);
          _context16.next = 16;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* EDIT_LABELS_FAILURE */] });

        case 16:
        case 'end':
          return _context16.stop();
      }
    }
  }, mailbox__marked[15], this, [[0, 11]]);
}

function createLabel(action) {
  var user, res, position, opts, dbRes;
  return regeneratorRuntime.wrap(function createLabel$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.prev = 0;
          _context17.next = 3;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(getUser);

        case 3:
          user = _context17.sent;
          _context17.next = 6;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(mailbox___WEBPACK_IMPORTED_MODULE_3__actions_mailbox__["createLabel"], user, action.labelName);

        case 6:
          res = _context17.sent;

          if (res.error) {
            _context17.next = 18;
            break;
          }

          // store in db
          position = action.oldLabelIndex + 1;

          console.log(position);
          opts = {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ labelId: res.id, position: position })
          };
          _context17.next = 13;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(fetch, '/api/add-label', opts);

        case 13:
          dbRes = _context17.sent;
          _context17.next = 16;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* CREATE_LABEL_SUCCESS */], oldLabelIndex: action.oldLabelIndex, newLabel: res });

        case 16:
          _context17.next = 20;
          break;

        case 18:
          _context17.next = 20;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* CREATE_LABEL_FAILURE */] });

        case 20:
          _context17.next = 27;
          break;

        case 22:
          _context17.prev = 22;
          _context17.t0 = _context17['catch'](0);

          console.log(_context17.t0);
          _context17.next = 27;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* CREATE_LABEL_FAILURE */] });

        case 27:
        case 'end':
          return _context17.stop();
      }
    }
  }, mailbox__marked[16], this, [[0, 22]]);
}

function watchAddLabelToShow(_ref2) {
  var fetch = _ref2.fetch;
  return regeneratorRuntime.wrap(function watchAddLabelToShow$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ADD_LABEL_TO_SHOW */], addLabelToShow, fetch);

        case 2:
        case 'end':
          return _context18.stop();
      }
    }
  }, mailbox__marked[17], this);
}

function watchChangeLabel() {
  return regeneratorRuntime.wrap(function watchChangeLabel$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* CHANGE_LABEL_TO_SHOW */], changeLabelToShow);

        case 2:
        case 'end':
          return _context19.stop();
      }
    }
  }, mailbox__marked[18], this);
}

function watchRemoveLabel() {
  return regeneratorRuntime.wrap(function watchRemoveLabel$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["h" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__constants__["J" /* REMOVE_LABEL_TO_SHOW */], removeLabelToShow);

        case 2:
        case 'end':
          return _context20.stop();
      }
    }
  }, mailbox__marked[19], this);
}

function watchMoveLabel() {
  return regeneratorRuntime.wrap(function watchMoveLabel$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["h" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__constants__["C" /* MOVE_LABEL */], moveLabelToShow);

        case 2:
        case 'end':
          return _context21.stop();
      }
    }
  }, mailbox__marked[20], this);
}

function watchMoveThread() {
  return regeneratorRuntime.wrap(function watchMoveThread$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__constants__["B" /* MOVE_CARD */], moveThread);

        case 2:
        case 'end':
          return _context22.stop();
      }
    }
  }, mailbox__marked[21], this);
}

function watchMarkAsRead() {
  return regeneratorRuntime.wrap(function watchMarkAsRead$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__constants__["z" /* MARK_AS_READ_REQUEST */], markAsRead);

        case 2:
        case 'end':
          return _context23.stop();
      }
    }
  }, mailbox__marked[22], this);
}

function watchArchiveThread() {
  return regeneratorRuntime.wrap(function watchArchiveThread$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* ARCHIVE_THREAD_REQUEST */], archiveThread);

        case 2:
        case 'end':
          return _context24.stop();
      }
    }
  }, mailbox__marked[23], this);
}

function watchTrashThread() {
  return regeneratorRuntime.wrap(function watchTrashThread$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__constants__["V" /* TRASH_THREAD_REQUEST */], trashThread);

        case 2:
        case 'end':
          return _context25.stop();
      }
    }
  }, mailbox__marked[24], this);
}

function watchCreateLabel() {
  return regeneratorRuntime.wrap(function watchCreateLabel$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__constants__["k" /* CREATE_LABEL_REQUEST */], createLabel);

        case 2:
        case 'end':
          return _context26.stop();
      }
    }
  }, mailbox__marked[25], this);
}

function watchRenameLabel() {
  return regeneratorRuntime.wrap(function watchRenameLabel$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          _context27.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__constants__["N" /* RENAME_LABEL_REQUEST */], renameLabel);

        case 2:
        case 'end':
          return _context27.stop();
      }
    }
  }, mailbox__marked[26], this);
}

function watchEditLabels() {
  return regeneratorRuntime.wrap(function watchEditLabels$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:
          _context28.next = 2;
          return Object(mailbox___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__constants__["n" /* EDIT_LABELS_REQUEST */], editLabels);

        case 2:
        case 'end':
          return _context28.stop();
      }
    }
  }, mailbox__marked[27], this);
}
// CONCATENATED MODULE: ./src/sagas/index.js
/* harmony import */ var sagas___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(77);
var sagas__marked = [rootSaga].map(regeneratorRuntime.mark);





function rootSaga(context) {
  return regeneratorRuntime.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(sagas___WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([watchAuth(context), watchFullSyncMailBox(), watchPartialSyncMailBox(), watchFetchAllLabels(), watchAddLabelToShow(context), watchChangeLabel(), watchRemoveLabel(), watchMoveLabel(), watchMoveThread(), watchMarkAsRead(), watchArchiveThread(), watchTrashThread(), watchCreateLabel(), watchRenameLabel(), watchEditLabels()]);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, sagas__marked[0], this);
}
// CONCATENATED MODULE: ./src/store/configureStore.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(151);
/* harmony import */ var configureStore___WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);








function configureStore(initialState, helpersConfig) {
  var helpers = createHelpers(helpersConfig);
  var sagaMiddleware = Object(configureStore___WEBPACK_IMPORTED_MODULE_1_redux_saga__["a" /* default */])();
  // const middleware = [sagaMiddleware, thunk.withExtraArgument(helpers)];
  var middleware = [sagaMiddleware];

  var enhancer = void 0;

  if (false) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    var devToolsExtension = function devToolsExtension(f) {
      return f;
    };
    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(applyMiddleware.apply(undefined, middleware), devToolsExtension);
  } else {
    enhancer = __WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined, middleware);
  }

  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  var store = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* createStore */])(reducers_defaultExport, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(initialState), enhancer);
  sagaMiddleware.run(rootSaga, helpers);

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (false) {
    module.hot.accept('../reducers', function () {
      return (
        // eslint-disable-next-line global-require
        store.replaceReducer(require('../reducers').default)
      );
    });
  }

  return store;
}
// CONCATENATED MODULE: ./src/DOMUtils.js
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

function updateTag(tagName, keyName, keyValue, attrName, attrValue) {
  var node = document.head.querySelector(tagName + '[' + keyName + '="' + keyValue + '"]');
  if (node && node.getAttribute(attrName) === attrValue) return;

  // Remove and create a new tag in order to make it work with bookmarks in Safari
  if (node) {
    node.parentNode.removeChild(node);
  }
  if (typeof attrValue === 'string') {
    var nextNode = document.createElement(tagName);
    nextNode.setAttribute(keyName, keyValue);
    nextNode.setAttribute(attrName, attrValue);
    document.head.appendChild(nextNode);
  }
}

function updateMeta(name, content) {
  updateTag('meta', 'name', name, 'content', content);
}

function updateCustomMeta(property, content) {
  updateTag('meta', 'property', property, 'content', content);
}

function updateLink(rel, href) {
  updateTag('link', 'rel', rel, 'href', href);
}
// CONCATENATED MODULE: ./src/routes/index.js
function routes__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

// The top-level (parent) route
var routes = {

  path: '/',

  // Keep in mind, routes are evaluated in order
  children: [{
    path: '/',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1076));
    }
  }, {
    path: '/login',
    load: function load() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1077));
    }
  }, {
    path: '/logout',
    load: function load() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1078));
    }
  }, {
    path: '/app',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1079));
    }
  },

  // Wildcard routes, e.g. { path: '*', ... } (must go last)
  {
    path: '*',
    load: function load() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1080));
    }
  }],

  action: function action(_ref) {
    var _this = this;

    var next = _ref.next;
    return routes__asyncToGenerator(regeneratorRuntime.mark(function _callee() {
      var route;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return next();

            case 2:
              route = _context.sent;


              // Provide default values for title, description etc.
              route.title = (route.title || 'Untitled Page') + ' - DraggyMail';
              route.description = route.description || '';

              return _context.abrupt('return', route);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

// The error page is available by permanent url for development mode
if (false) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default
  });
}

/* harmony default export */ var routes_defaultExport = (routes);
// CONCATENATED MODULE: ./src/router.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_router__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_universal_router__);
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */




/* harmony default export */ var router_defaultExport = (new __WEBPACK_IMPORTED_MODULE_0_universal_router___default.a(routes_defaultExport, {
  resolveRoute: function resolveRoute(context, params) {
    if (typeof context.route.load === 'function') {
      return context.route.load().then(function (action) {
        return action.default(context, params);
      });
    }
    if (typeof context.route.action === 'function') {
      return context.route.action(context, params);
    }
    return null;
  }
}));
// CONCATENATED MODULE: ./src/client.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_deep_force_update__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_deep_force_update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_deep_force_update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history_PathUtils__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__history__ = __webpack_require__(225);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var client__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Re-render the app when window.location changes
var onLocationChange = function () {
  var _ref = client__asyncToGenerator(regeneratorRuntime.mark(function _callee(location, action) {
    var route;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Remember the latest scroll position for the previous location
            scrollPositionsHistory[currentLocation.key] = {
              scrollX: window.pageXOffset,
              scrollY: window.pageYOffset
            };
            // Delete stored scroll position for next page if any
            if (action === 'PUSH') {
              delete scrollPositionsHistory[location.key];
            }
            currentLocation = location;

            _context.prev = 3;
            _context.next = 6;
            return router_defaultExport.resolve(client__extends({}, client_context, {
              path: location.pathname,
              query: __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(location.search)
            }));

          case 6:
            route = _context.sent;

            if (!(currentLocation.key !== location.key)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt('return');

          case 9:
            if (!route.redirect) {
              _context.next = 12;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_9__history__["a" /* default */].replace(route.redirect);
            return _context.abrupt('return');

          case 12:

            appInstance = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(_jsx(App_defaultExport, {
              context: client_context
            }, void 0, route.component), container, function () {
              return onRenderComplete(route, location);
            });
            _context.next = 21;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context['catch'](3);

            if (true) {
              _context.next = 19;
              break;
            }

            throw _context.t0;

          case 19:

            console.error(_context.t0);

            // Do a full page reload if error occurs during client-side navigation
            if (action && currentLocation.key === location.key) {
              window.location.reload();
            }

          case 21:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 15]]);
  }));

  return function onLocationChange(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// Handle client-side navigation by using HTML5 History API
// For more information visit https://github.com/mjackson/history#readme


function client__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */














/* eslint-disable global-require */

// Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html
var client_context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: function insertCss() {
    for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    // eslint-disable-next-line no-underscore-dangle
    var removeCss = styles.map(function (x) {
      return x._insertCss();
    });
    return function () {
      removeCss.forEach(function (f) {
        return f();
      });
    };
  },
  // Universal HTTP client
  fetch: createFetch_defaultExport(self.fetch, {
    baseUrl: window.App.apiUrl
  }),
  // Initialize a new Redux store
  // http://redux.js.org/docs/basics/UsageWithReact.html
  store: configureStore(window.App.state, { history: __WEBPACK_IMPORTED_MODULE_9__history__["a" /* default */] }),
  storeSubscription: null
};

// Switch off the native scroll restoration behavior and handle it manually
// https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
var scrollPositionsHistory = {};
if (window.history && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

var onRenderComplete = function initialRenderComplete() {
  var elem = document.getElementById('css');
  if (elem) elem.parentNode.removeChild(elem);
  onRenderComplete = function renderComplete(route, location) {
    document.title = route.title;

    updateMeta('description', route.description);
    // Update necessary tags in <head> at runtime here, ie:
    // updateMeta('keywords', route.keywords);
    // updateCustomMeta('og:url', route.canonicalUrl);
    // updateCustomMeta('og:image', route.imageUrl);
    // updateLink('canonical', route.canonicalUrl);
    // etc.

    var scrollX = 0;
    var scrollY = 0;
    var pos = scrollPositionsHistory[location.key];
    if (pos) {
      scrollX = pos.scrollX;
      scrollY = pos.scrollY;
    } else {
      var targetHash = location.hash.substr(1);
      if (targetHash) {
        var target = document.getElementById(targetHash);
        if (target) {
          scrollY = window.pageYOffset + target.getBoundingClientRect().top;
        }
      }
    }

    // Restore the scroll position if it was saved into the state
    // or scroll to the given #hash anchor
    // or scroll to top of the page
    window.scrollTo(scrollX, scrollY);

    // Google Analytics tracking. Don't send 'pageview' event after
    // the initial rendering, as it was already sent
    if (window.ga) {
      window.ga('send', 'pageview', Object(__WEBPACK_IMPORTED_MODULE_5_history_PathUtils__["createPath"])(location));
    }
  };
};

var container = document.getElementById('app');
var appInstance = void 0;
var currentLocation = __WEBPACK_IMPORTED_MODULE_9__history__["a" /* default */].location;__WEBPACK_IMPORTED_MODULE_9__history__["a" /* default */].listen(onLocationChange);
onLocationChange(currentLocation);

// Enable Hot Module Replacement (HMR)
if (false) {
  module.hot.accept('./router', function () {
    if (appInstance) {
      // Force-update the whole tree, including components that refuse to update
      deepForceUpdate(appInstance);
    }

    onLocationChange(currentLocation);
  });
}

/***/ })

},[228]);


// WEBPACK FOOTER //
// client.722792d1.js